// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"87661036","79":"faac7abc","109":"ad204922","144":"d4706ca7","185":"15a3aca2","285":"7c567a04","974":"4ff47313"}[chunkId] + ".js";
};